export { default } from './Typography';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Typography/index.js
// module id = 72
// module chunks = 2